import { Reducer } from '@reduxjs/toolkit';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IDispatcherType = any;

export interface IError {
	name: string;
	message: string;
	code: string;
	stack: string;
	data?: unknown;
	api_msg?: string;
}

export interface FaqItem {
	id: string | number;
	question: string;
}

export interface ISampleResponse {
	message: string;
	api_msg?: string;
	data?: unknown;
	status_code?: string;
	success?: boolean;
}

export interface ObStatus {
	statusOfRequestedKycRanking: string;
	deeplink: string;
	status: string;
	activatedViaNewObV3?: boolean;
}

export interface INewResponse<T> {
	message: string;
	api_msg?: string;
	data?: T;
	status_code?: string;
	success?: boolean;
}

export interface IInitialState {
	loading: boolean;
	isFetched: boolean;
	error: string;
	data: unknown;
}

export const INITIAL_STATE = (): IInitialState => ({
	loading: false,
	isFetched: false,
	error: '',
	data: {},
});

export interface IACTION<T = unknown> {
	type: string | symbol;
	payload: T;
}

export interface IAPI_ACTION<T = unknown> extends IACTION<T> {
	meta: unknown;
	error: {
		name: string;
		message: string;
		stack: string;
	};
}

export interface ISimpleMap {
	[field: string]: Reducer;
}

export interface IGetParams {
	[field: string]: string | number;
}

export type ILanguage = 'en' | 'hi' | 'kn' | 'te' | 'ta' | 'bn' | 'gu' | 'ml' | 'mr';
